import { makeRequestGet, makeRequestGet2, makeRequestPost2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getOrders() {
  let token = await getToken();
  return makeRequestGet2(`orders/`, token);
}

export async function postOrder(data) {
  let token = await getToken();
  return makeRequestPost2(`orders/`, data, token);
}